import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LabelEditForm } from "./components/LabelEditForm";

export function EditLabelPage() {
  return (
    <Page title="Edit Label">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LabelEditForm />
      </Container>
    </Page>
  );
}
